<template>
    <div class="dropdown-field" :data-id="id">
        <div class="input-wrapper">
            <input type="text" @focus="visible=true;" @input="queried=true;" v-model="query" :style="{'cursor':visible?'':'pointer'}"/>
            <div class="dropdown-pipe" @click="visible = !visible">
                <div class="pipe-container"></div>
            </div>
        </div>
        <transition name="bounce">
            <div class="options" v-show="visible">
                <ul>
                    <li v-for="(option,option_index) in list" :value="option.value" :key="option_index" v-html="option.label" @click="select(option)" :class="{'selected':selected==option.value}"></li>
                </ul>
            </div>
        </transition>
    </div>
</template>
<style lang="scss">
    .dropdown-field{
        &>.input-wrapper{
            &>input[type="text"]{
                width:100%;
                max-width: 100%;
                margin-bottom: 0px;
            }
            .dropdown-pipe{
                cursor: pointer;
                display: flex;
                align-items:center;
                justify-content: center;
                position: absolute;
                top: 0px;
                right: 0px;
                bottom: 0px;
                width: 50px;
                .pipe-container{
                    display: flex;
                    align-items:center;
                    justify-content: center;
                    width:21px;
                    height: 10px;
                    &:before,&:after{
                        display:block;
                        content:"";
                        background: #595959;
                        height: 3px;
                        width: 11px;
                        transform: rotate(0deg);
                        transform-origin: 50% 50%;
                        position:absolute;
                        border-radius: 2px;
                    }
                    &::before{
                        transform: rotate(45deg);   
                        margin-left: -7px;
                    }
                    &:after{
                        transform: rotate(-45deg);    
                        margin-left: 7px;
                    }
                }
            }
        }
        >.options{
            background: #FFFFFF;
            box-shadow: 0px 2px 4px rgba(0,0,0,0.2);
            border-radius: 10px;
            z-index: 1001;
            position: absolute;
            width: 100%;
            top: calc(100% + 4px);
            overflow: hidden;
            max-height: 400px;
            overflow: auto;
            ul{
                list-style: none;
                margin: 0px;
                padding: 0px;
                li{
                    cursor: pointer;    
                    padding: 16px 12px;
                    font-family: FuturaPT;
                    font-size: 16px;
                    line-height: 20px;
                    letter-spacing: 0.5px;
                    color: #0B1022;
                    &:hover{
                        background: #F0F3F8;
                    }
                    &.selected{
                        color: #CF0920;;
                    }
                }
            }
        }
    }
    .bounce-enter-active {
        animation: bounce-in .3s;
    }

    .bounce-leave-active {
        animation: bounce-in .3s reverse;
    }

    @keyframes bounce-in {
        0% {
        transform: scale(0);
        }
        50% {
        transform: scale(1.1);
        }
        100% {
        transform: scale(1);
        }
    }

    .opacity-enter-active {
        animation: opacity-in .3s;
    }

    .opacity-leave-active {
        animation: opacity-in .3s reverse;
    }

    @keyframes opacity-in {
        0% {
        opacity: 0;
        }
        100% {
        opacity: 1;
        }
    }
</style>

<script>
    import {randomString} from '@/utils/utils';

    export default {
        name:'DropDown',
        components:{
            
        },
        data:function(){
            return{
                visible:false,
                query:"",
                id:randomString(),
                queried:false,
                value:null
            }
        },
        model:{
            prop:"value",
            event:"change"
        },
        props:{
            options:{
                type:Array,
                default:[],
                required:true
            },
            selected:{
                type:String,
                default:"",
                required:false
            },
        },
        mounted(){
            document.addEventListener("mousedown",(e)=>{
                if(this.visible){
                    var c = e.target.closest(".dropdown-field");
                    if(c){
                        var i = c.dataset['id'];
                        if(i && i == this.id){
                            return true;
                        }
                    }
                    this.visible = false;
                }
            });
            this.defaults();
        },
        computed:{
            list(){
                var l = [];
                if(this.query && this.queried && this.query.toString().trim().length>0){
                    var m = this.query.toString().trim();
                    for(var x in this.options){
                        if(this.options[x].label.indexOf(m)>=0){
                            l.push(this.options[x]);
                        }
                    }
                }else{
                    l = this.options;
                }
                return l;
            }
        },
        methods:{
            select(option){
                this.value = option.value;
                this.query = option.label;
                this.visible=false;
            },
            defaults(){
                if(this.selected){
                    //Ищем значение в списке
                    for(var x in this.options){
                        if(this.options[x].value.toString() == this.selected.toString()){
                            this.value = this.selected;
                            this.query = this.options[x].label;
                            break;
                        }
                    }
                }
            }
        },
        watch:{
            value(){
                this.$emit("change",this.value);
            },
            visible(){
                this.queried=false;
            },
            selected(){
                this.defaults();
            }
        }
    }
</script>